import { ApiError } from '../../../../resources/ApiError';

/**
 * 가입(v5 이메일 / v3 소셜) 요청이 휴대폰 인증 때문에 실패했을 때 오는 errorCode.
 * 모두 번호를 다시 인증하면 해결되므로 화면을 떠나지 않고 인증 단계만 초기화한다.
 */
const SIGNUP_PHONE_VERIFICATION_ERROR_CODES = [
  'PHONE_VERIFICATION_NOT_FOUND',
  'INVALID_AUTHENTICATION_CODE',
  'NOT_AUTHENTICATED',
  'AUTHENTICATION_CODE_EXPIRED',
  'PHONE_VERIFICATION_ALREADY_USED',
];

export const isSignupPhoneVerificationError = (error: unknown) =>
  ApiError.isApiError(error) &&
  SIGNUP_PHONE_VERIFICATION_ERROR_CODES.includes(error.errorCode ?? '');
